import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewProveedor = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'proveedor',
        name: 'Proveedor',
        component: ViewProveedor,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
